module.exports = __webpack_public_path__ + "img/module2-02.e27bad12.jpg";